module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-rtu-permalip_4_after_tn.jpg
// module id = 1847
// module chunks = 0